// extracted by mini-css-extract-plugin
export var cols2 = "grid-module--cols2--r22Wc";
export var grid = "grid-module--grid---CKqs";